import { useLocation, Link } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-background-50 flex flex-col items-center justify-center text-center px-4">
      <div className="relative">
        <h1 className="text-9xl md:text-[12rem] font-black text-background-200 select-none pointer-events-none">
          404
        </h1>
        <div className="mt-6">
          <h1 className="text-xl md:text-2xl font-semibold text-foreground-700">
            페이지를 찾을 수 없습니다
          </h1>
          <p className="mt-2 text-sm text-foreground-600 font-mono">
            {location.pathname}
          </p>
          <p className="mt-4 text-sm text-foreground-600">
            요청하신 페이지가 존재하지 않거나 이동되었습니다
          </p>
          <Link
            to="/"
            className="inline-flex items-center gap-2 mt-6 px-6 py-2.5 bg-primary-500 text-foreground-50 text-sm font-bold rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-home-line" />
            </span>
            홈으로 돌아가기
          </Link>
        </div>
      </div>
    </div>
  );
}